// extracted by mini-css-extract-plugin
export default {"securityRulesTable":"security-rules-table-container__security-rules-table__udHjY"};